import { WidgetType } from 'types/widget.types';

import {
  DEFAULT_COLUMN_CHART_MULTI_SERIES_DATA,
  DEFAULT_COLUMN_CHART_SINGLE_SERIES_DATA,
  DEFAULT_HEIGHT,
  DEFAULT_WIDTH,
} from './ColumnChartWidget.config';
import { ColumnChartWidgetData } from './ColumnChartWidget.types';
import { VERSION } from './ColumnChartWidget.upgrade';

const DEFAULT_WIDGET_DATA = {
  version: VERSION,
  widthPx: DEFAULT_WIDTH,
  heightPx: DEFAULT_HEIGHT,
  topPx: 0,
  leftPx: 0,
  rotateDeg: 0,
  altText: '',
  isDecorative: false,
};

export const generateDefaultData = () => {
  return {
    widgetType: WidgetType.ColumnChart,
    widgetData: {
      ...DEFAULT_WIDGET_DATA,
      ...DEFAULT_COLUMN_CHART_SINGLE_SERIES_DATA,
    } as ColumnChartWidgetData,
  };
};

export const generateDefaultMultiSeriesData = () => {
  return {
    widgetType: WidgetType.ColumnChart,
    widgetData: {
      ...DEFAULT_WIDGET_DATA,
      ...DEFAULT_COLUMN_CHART_MULTI_SERIES_DATA,
    } as ColumnChartWidgetData,
  };
};
